module.exports = __webpack_public_path__ + "img/orange.1aead762.png";